function isEmptyValue(value) {
  return value === null || value === undefined || value === ''
}

function toNumberOrNull(value) {
  if (isEmptyValue(value)) return null

  const parsed = Number(value)
  return Number.isNaN(parsed) ? null : parsed
}

const CHART_SPLIT_RULES = {
  'MP-01': {
    percentage: [
      {
        key: 'meta_lt_50',
        label: 'Meta < 50',
        match: (row) => {
          const objective = toNumberOrNull(row.objective)
          return objective === null || objective < 50
        },
      },
      {
        key: 'meta_gte_50',
        label: 'Meta >= 50',
        match: (row) => {
          const objective = toNumberOrNull(row.objective)
          return objective !== null && objective >= 50
        },
      },
    ],
  },
  'MP-02': {
    raw: [
      {
        key: 'meta_gt_5',
        label: 'Meta > 5',
        match: (row) => {
          const objective = toNumberOrNull(row.objective)
          return objective === null || objective > 5
        },
      },
      {
        key: 'meta_lte_5',
        label: 'Meta <= 5',
        match: (row) => {
          const objective = toNumberOrNull(row.objective)
          return objective !== null && objective <= 5
        },
      },
    ],
  },
  'MP-03': {
    percentage: [
      {
        key: 'meta_gte_50',
        label: 'Meta >= 50',
        match: (row) => toNumberOrNull(row.objective) !== null && toNumberOrNull(row.objective) >= 50,
      },
      {
        key: 'meta_lt_50',
        label: 'Meta < 50',
        match: (row) => toNumberOrNull(row.objective) !== null && toNumberOrNull(row.objective) < 50,
      },
    ],
    raw: [
      {
        key: 'value_gt_10',
        label: 'Valor > 10',
        match: (row) => toNumberOrNull(row.obtained) !== null && toNumberOrNull(row.obtained) > 10,
      },
      {
        key: 'value_lte_10',
        label: 'Valor <= 10',
        match: (row) => toNumberOrNull(row.obtained) !== null && toNumberOrNull(row.obtained) <= 10,
      },
    ],
  },
  'MP-04': {
    raw: [
      {
        key: 'no_meta',
        label: 'Sem meta',
        showObjectiveSeries: false,
        match: (row) => isEmptyValue(row.objective),
      },
      {
        key: 'meta_gt_10',
        label: 'Meta > 10',
        match: (row) => toNumberOrNull(row.objective) !== null && toNumberOrNull(row.objective) > 10,
      },
      {
        key: 'remaining',
        label: 'Restantes',
        match: (row) => toNumberOrNull(row.objective) !== null && toNumberOrNull(row.objective) <= 10,
      },
    ],
  },
  'MP-06': {
    percentage: [
      {
        key: 'no_meta',
        label: 'Sem meta',
        showObjectiveSeries: false,
        match: (row) => isEmptyValue(row.objective),
      },
      {
        key: 'meta_lt_50',
        label: 'Meta < 50',
        match: (row) => toNumberOrNull(row.objective) !== null && toNumberOrNull(row.objective) < 50,
      },
      {
        key: 'meta_gte_50',
        label: 'Meta >= 50',
        match: (row) => toNumberOrNull(row.objective) !== null && toNumberOrNull(row.objective) >= 50,
      },
    ],
    raw: [
      {
        key: 'value_gt_10',
        label: 'Valor > 10',
        match: (row) => toNumberOrNull(row.obtained) !== null && toNumberOrNull(row.obtained) > 10,
      },
      {
        key: 'value_lte_10',
        label: 'Valor <= 10',
        match: (row) => toNumberOrNull(row.obtained) !== null && toNumberOrNull(row.obtained) <= 10,
      },
    ],
  },
}

export function getChartSplitDefinitions(group, valueType) {
  return CHART_SPLIT_RULES[group]?.[valueType] || null
}

export function resolveChartSplit(group, valueType, row = {}) {
  const definitions = getChartSplitDefinitions(group, valueType)

  if (!definitions?.length) {
    return {
      key: 'default',
      label: null,
      showObjectiveSeries: true,
    }
  }

  const matchedDefinition =
    definitions.find((definition) => definition.match(row)) || definitions[definitions.length - 1]

  return {
    key: matchedDefinition.key,
    label: matchedDefinition.label,
    showObjectiveSeries: matchedDefinition.showObjectiveSeries ?? true,
  }
}
